module.exports = __webpack_public_path__ + "img/teacher_settings_button.0bee5f58.jpg";